import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tag, Sparkles } from "lucide-react";
import api, { asList } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

const COUPONS = [
  { code: "BEMVINDO10", text: "10% OFF na primeira compra" },
  { code: "NATURAL20", text: "20% OFF acima de R$150" },
  { code: "SAUDE15", text: "R$15 OFF acima de R$80" },
];

export default function Promocoes() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(asList(r.data))).catch(() => setProducts([]));
  }, []);
  const onSale = asList(products).filter((p) => p.sale_price != null && p.sale_price < p.price);

  return (
    <div className="mx-auto max-w-[1280px] px-4 py-10 sm:px-6">
      {/* Banner */}
      <section className="overflow-hidden rounded-2xl bg-forest-deep p-8 text-alabaster sm:p-12">
        <div className="flex items-center gap-2 font-sans text-xs font-semibold uppercase tracking-[0.2em] text-ochre">
          <Sparkles size={16} /> Ofertas da semana
        </div>
        <h1 className="mt-3 font-serif text-4xl font-semibold sm:text-5xl">Promoções</h1>
        <p className="mt-3 max-w-lg font-sans text-sm text-alabaster/70">Os melhores produtos naturais com os melhores preços. Aproveite enquanto durar!</p>
      </section>

      {/* Coupons */}
      <section className="mt-8">
        <h2 className="mb-4 flex items-center gap-2 font-serif text-2xl font-semibold text-forest-deep"><Tag size={22} className="text-clay" /> Cupons de desconto</h2>
        <div className="grid gap-4 sm:grid-cols-3">
          {COUPONS.map((c) => (
            <div key={c.code} data-testid={`coupon-${c.code}`} className="flex items-center justify-between rounded-xl border-2 border-dashed border-clay/40 bg-sand-elevated p-5">
              <div>
                <p className="font-mono text-lg font-bold text-forest-deep">{c.code}</p>
                <p className="mt-1 font-sans text-xs text-ink/60">{c.text}</p>
              </div>
              <span className="rounded-md bg-clay px-3 py-1.5 font-sans text-xs font-semibold text-white">Aplicar no carrinho</span>
            </div>
          ))}
        </div>
      </section>

      {/* Products on sale */}
      <section className="mt-10">
        <h2 className="mb-6 font-serif text-2xl font-semibold text-forest-deep sm:text-3xl">Produtos em oferta</h2>
        {onSale.length === 0 ? (
          <p className="py-16 text-center font-serif text-2xl text-ink/40">Nenhuma promoção no momento.</p>
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {onSale.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
        <div className="mt-10 text-center">
          <Link to="/loja" className="inline-block rounded-lg border border-forest-deep px-6 py-3 font-sans text-sm font-semibold uppercase tracking-wide text-forest-deep transition-colors hover:bg-forest-deep hover:text-white">
            Ver todos os produtos
          </Link>
        </div>
      </section>
    </div>
  );
}
